document.addEventListener("DOMContentLoaded", function () {
  let flagImage = document.getElementById("current-lang-flag");
  let openSelector = document.getElementById("open-lang-selector");
  let marketSwitcherRoot = document.querySelector("[data-market-switcher]");
  let flagMap = {
    DK: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/denmark.png?v=1742990123",
    SE: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/sweden.png?v=1742990968",
    NO: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/norway.png?v=1742991092",
    FI: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/findland.png?v=1742991571",
    DE: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/germany.png?v=1742990123",
    FR: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/france.png?v=1742992825",
    IT: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/flag.png?v=1742992824",
    ES: "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/world.png?v=1742992825",
    NL: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/netherlands.png?v=1746438517",
    EE: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Estonia_svg.png?v=1746440898",
    LV: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/latvia.png?v=1746441665",
    LT: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Lithuania.png?v=1746448397",
    PL: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Poland.png?v=1746447118",
    AT: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Austria_svg.png?v=1746448445",
    BE: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Belgium.png?v=1746448509",
    LU: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_Luxembourg_svg.png?v=1746448566",
    CZ: "https://cdn.shopify.com/s/files/1/0910/4090/7587/files/Flag_of_the_Czech_Republic_svg.webp?v=1746448625"
  };
  let hostMap = {
    "soundstorexl.dk": "DK",
    "www.soundstorexl.dk": "DK",
    "soundstorexl.se": "SE",
    "www.soundstorexl.se": "SE",
    "soundstorexl.no": "NO",
    "www.soundstorexl.no": "NO",
    "soundstorexl.fi": "FI",
    "www.soundstorexl.fi": "FI",
    "soundstorexl.de": "DE",
    "www.soundstorexl.de": "DE",
    "soundstorexl.fr": "FR",
    "www.soundstorexl.fr": "FR",
    "soundstorexl.it": "IT",
    "www.soundstorexl.it": "IT",
    "soundstorexl.es": "ES",
    "www.soundstorexl.es": "ES",
    "soundstorexl.com": "EN",
    "www.soundstorexl.com": "EN"
  };
  let marketDomainMap = {
    DK: "https://soundstorexl.dk",
    SE: "https://soundstorexl.se",
    NO: "https://soundstorexl.no",
    FI: "https://soundstorexl.fi",
    DE: "https://soundstorexl.de",
    FR: "https://soundstorexl.fr",
    IT: "https://soundstorexl.it",
    ES: "https://soundstorexl.es"
  };
  let fallbackMarketBaseUrl = "https://soundstorexl.com";
  let fallbackFlag = "https://cdn.shopify.com/s/files/1/0904/7120/3185/files/EU.png?v=1742991477";

  (function updateFlag(retries = 20) {
    if (!flagImage) return;
    let hostname = window.location.hostname;
    let isComDomain = hostname === "soundstorexl.com" || hostname === "www.soundstorexl.com";
    let htmlLang = String(document.documentElement?.lang || "").toLowerCase();
    let shopifyLocale = String(window.Shopify?.locale || "").toLowerCase();
    let isEnglishLocale = htmlLang.startsWith("en") || shopifyLocale.startsWith("en");

    // Always show EU flag on .com when English locale is active.
    if (isComDomain && isEnglishLocale) {
      flagImage.src = fallbackFlag;
      flagImage.decoding = "async";
      flagImage.loading = "eager";
      flagImage.style.cursor = "pointer";
      return;
    }

    let currentCountry = (function getCountryCode() {
      try {
        if (window.Shopify && Shopify.country) {
          return String(Shopify.country).toUpperCase();
        }
      } catch (error) {}

      return hostMap[window.location.hostname] || null;
    })();

    if (currentCountry && flagMap[currentCountry]) {
      flagImage.src = flagMap[currentCountry];
      flagImage.decoding = "async";
      flagImage.loading = "eager";
      flagImage.style.cursor = "pointer";
    } else if (retries > 0) {
      flagImage.src = fallbackFlag;
      setTimeout(() => updateFlag(retries - 1), 150);
    } else {
      flagImage.src = fallbackFlag;
      flagImage.style.cursor = "pointer";
    }
  })();

  if (marketSwitcherRoot && openSelector) {
    const popoverId = "market-switcher-popover";

    const popover = document.createElement("div");
    popover.id = popoverId;
    popover.className = "market-switcher__popover";
    popover.setAttribute("role", "menu");

    const countryNames = {
      DK: "Denmark",
      SE: "Sweden",
      NO: "Norway",
      FI: "Finland",
      DE: "Germany",
      FR: "France",
      IT: "Italy",
      ES: "Spain",
      NL: "Netherlands",
      EE: "Estonia",
      LV: "Latvia",
      LT: "Lithuania",
      PL: "Poland",
      AT: "Austria",
      BE: "Belgium",
      LU: "Luxembourg",
      CZ: "Czechia",
    };

    popover.innerHTML = `
      <div class="market-switcher__list" role="none">
        ${Object.entries(countryNames)
          .map(([countryCode, countryName]) => {
            const flagUrl = flagMap[countryCode] || "";
            return `
              <button type="button" class="market-switcher__item" role="menuitem" data-country-code="${countryCode}">
                <img class="market-switcher__flag" src="${flagUrl}" alt="${countryName}" loading="lazy" decoding="async" />
                <span class="market-switcher__name">${countryName}</span>
              </button>
            `;
          })
          .join("")}
      </div>
    `;

    marketSwitcherRoot.appendChild(popover);

    const setOpen = (isOpen) => {
      marketSwitcherRoot.classList.toggle("is-open", isOpen);
      openSelector.setAttribute("aria-expanded", String(isOpen));
      if (!isOpen) {
        openSelector.focus();
      }
    };

    const toggleOpen = () => {
      setOpen(!marketSwitcherRoot.classList.contains("is-open"));
    };

    openSelector.setAttribute("aria-haspopup", "menu");
    openSelector.setAttribute("aria-controls", popoverId);
    openSelector.setAttribute("aria-expanded", "false");

    openSelector.addEventListener("click", (event) => {
      event.preventDefault();
      toggleOpen();
    });

    document.addEventListener("click", (event) => {
      if (!marketSwitcherRoot.classList.contains("is-open")) return;
      if (marketSwitcherRoot.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (!marketSwitcherRoot.classList.contains("is-open")) return;
      event.preventDefault();
      setOpen(false);
    });

    popover.addEventListener("click", (event) => {
      const item = event.target.closest(".market-switcher__item");
      if (!item) return;

      const countryCodeUpper = String(item.dataset.countryCode || "").toUpperCase();
      const countryCode = countryCodeUpper.toLowerCase();
      const marketBaseUrl = marketDomainMap[countryCodeUpper] || fallbackMarketBaseUrl;

      const path = window.location.pathname;
      const hash = window.location.hash;
      const isSafePath = !/\/(checkout|account|cart|policies)(\/|$)/i.test(path);
      const targetPath = isSafePath ? path : "/";

      window.location.href = `${marketBaseUrl}${targetPath}?country=${countryCode}${hash}`;
    });
  }

  try {
    let url = new URL(window.location.href);
    if (url.searchParams.has("country")) {
      url.searchParams.delete("country");
      window.history.replaceState({}, document.title, url.pathname + url.hash);
    }
  } catch (error) {}
});